<div class="activity-container">
  <div class="header mt-3 mb-3">
    <h2 class="d-flex row modal-title text-center heading2">
      <div class="col-1">
        <img
          src="/assets/svg/ico-chevron-back-outline.svg"
          class="pointer-cursor back-icon"
          (click)="navigateBack()"
        />
      </div>
      <div class="col-10 pl-4">
        <div class="top-heading">
          <app-with-tooltip [showHelpCursor]="true">{{
            selectedSite?.siteName
          }}</app-with-tooltip>
        </div>
        <div class="heading2-text">
          <app-with-tooltip [showHelpCursor]="true">{{
            "MASTER_CREDENTIAL" | translate
          }}</app-with-tooltip>
        </div>
      </div>
      <div class="col-1" (click)="closeDialog()">
        <img
          src="/assets/svg/ico-hamburger-close.svg"
          class="pointer-cursor close-icon"
        />
      </div>
    </h2>
    <br />
    <h1 class="text-center heading1">{{ "ACTIVITIES" | translate }}</h1>
    <div class="text-center total-records" *ngIf="totalRecords > 0">
      {{ events.length }} of {{ totalRecords }}
    </div>
  </div>

  <!-- No data message: only when there are truly zero events -->
  <div
    class="no-data-container"
    *ngIf="!isInitialLoad && events.length === 0 && !isFetching"
  >
    <span>{{ "NO_ACTIVITIES_AVAILABLE" | translate }}</span>
  </div>

  <div
    class="form-container rounded-top p-2"
    cdkScrollable
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollUpDistance]="3"
    [infiniteScrollThrottle]="100"
    [scrollWindow]="false"
    (scrolled)="onScrollDown()"
    aria-live="polite"
    [attr.aria-busy]="loadingMore ? 'true' : 'false'"
    *ngIf="events.length > 0"
  >
    <div class="activities-cards-wrapper">
      <div
        *ngFor="let event of events; trackBy: trackByEvent"
        class="activity-card"
        [ngClass]="getSeverityClass(event)"
      >
        <div class="activity-card-wrapper">
          <div class="activity-content">
            <div class="activity-icon-section">
              <img
                [src]="getEventIcon(event)"
                alt="icon"
                class="activity-icon"
              />
            </div>

            <div class="activity-details">
              <div class="activity-title">
                <div class="lock-name-wrap">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ event.deviceName }}
                  </app-with-tooltip>
                </div>
                <span class="activity-title-status" *ngIf="event.eventTitle">
                  <app-with-tooltip [showHelpCursor]="true"
                    >: {{ event.eventTitle }}</app-with-tooltip
                  >
                </span>
              </div>

              <!-- Extra description: for specific codes or abnormal/issue events -->
              <div
                class="activity-description"
                *ngIf="event.extraDescription && hasExtraDescription(event)"
              >
                <app-with-tooltip
                  [showHelpCursor]="true"
                  class="description-text"
                  >{{ event.extraDescription }}</app-with-tooltip
                >
              </div>

              <!-- Source line: source | sourceName - ID.badgeId -->
              <div class="activity-source" *ngIf="event.source">
                <img
                  src="assets/svg/ico-lock-access-settings.svg"
                  alt="icon"
                  class="source-icon"
                />
                <app-with-tooltip [showHelpCursor]="true" class="source-text">{{
                  getSourceDisplay(event)
                }}</app-with-tooltip>
              </div>

              <!-- User name on its own line -->
              <div class="activity-user" *ngIf="event.user">
                <app-with-tooltip [showHelpCursor]="true" class="user-text">{{
                  event.user
                }}</app-with-tooltip>
              </div>
            </div>

            <div class="activity-metadata">
              <div class="activity-date">
                {{ event.isoTime | parsedActivityDateTime : "MMM dd" : true }}
              </div>
              <div class="activity-time">
                {{ event.isoTime | parsedDateTime : "hh:mm a" }}
              </div>
            </div>
          </div>

          <!-- Collapsed location bar (hidden when expanded) -->
          <div
            class="activity-location"
            *ngIf="expandedActivityId !== event.id"
          >
            <div class="location-items">
              <div class="location-group" *ngIf="event.buildingName">
                <span class="location-icon">
                  <img src="assets/svg/ico-building-gray.svg" alt="icon" />
                </span>
                <span class="location-name">
                  <app-with-tooltip [showHelpCursor]="true">{{
                    event.buildingName
                  }}</app-with-tooltip>
                </span>
              </div>
              <div class="location-group" *ngIf="event.unitName">
                <span class="location-icon">
                  <img src="assets/svg/ico-default-home.svg" alt="icon" />
                </span>
                <span class="location-name">
                  <app-with-tooltip [showHelpCursor]="true">{{
                    event.unitName
                  }}</app-with-tooltip>
                </span>
              </div>
            </div>
            <span
              class="chevron-dropdown-container"
              (click)="toggleDropdown(event.id)"
            >
              <img
                src="assets/svg/ico-chevron-down-outline-all-acces.svg"
                class="pointer-cursor chevron-icon"
              />
            </span>
          </div>

          <!-- Expanded location details (replaces collapsed bar) -->
          <div
            class="activity-location-expanded"
            *ngIf="expandedActivityId === event.id"
          >
            <div class="expanded-header">
              <span
                class="chevron-dropdown-container"
                (click)="toggleDropdown(event.id)"
              >
                <img
                  src="assets/svg/ico-up-arrow.svg"
                  class="pointer-cursor chevron-icon"
                />
              </span>
            </div>
            <div class="dropdown-detail-item" *ngIf="event.buildingName">
              <img
                src="assets/svg/ico-building-gray.svg"
                alt="building"
                class="dropdown-detail-icon"
              />
              <span class="dropdown-detail-text">{{ event.buildingName }}</span>
            </div>
            <div class="dropdown-detail-item" *ngIf="event.floorName">
              <img
                src="assets/svg/ico-floor.svg"
                alt="floor"
                class="dropdown-detail-icon"
              />
              <span class="dropdown-detail-text">{{ event.floorName }}</span>
            </div>
            <div class="dropdown-detail-item" *ngIf="event.wingName">
              <img
                src="assets/svg/ico-direction.svg"
                alt="wing"
                class="dropdown-detail-icon"
              />
              <span class="dropdown-detail-text">{{ event.wingName }}</span>
            </div>
            <div class="dropdown-detail-item" *ngIf="event.unitName">
              <img
                src="assets/svg/ico-default-home.svg"
                alt="unit"
                class="dropdown-detail-icon"
              />
              <span class="dropdown-detail-text">{{ event.unitName }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Load more spinner -->
      <div class="load-more-container" *ngIf="loadingMore">
        <div class="spinner-small"></div>
        <span>Loading more...</span>
      </div>
    </div>
  </div>
</div>
